import { Vue } from "vue-class-component";
import Swal from "sweetalert2";

export default class management extends Vue {
}

